import { styled, Button } from "@mui/material";

export const StyledButton = styled(Button)(({ theme }) => ({
  width: "200px",
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  fontSize: "18px",
  fontWeight: "600",
  lineHeight: "24px",
  padding: "14px 32px",
  borderRadius: "8px",
  textTransform: "none",
  boxShadow: "none",
  alignSelf: "center",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
    boxShadow: "none",
  },
  "&:active": {
    backgroundColor: theme.palette.secondary.darker,
  },
  "&:disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));
